export enum Packages {
    PFPF = "PFPF",
    PFF = "PFF",
    HF = "HF",
    PFPCS = "PFPCS",
    PFTT = "PFTT",
    HTT = "HTT",
    HTTF = "HTTF",
    PFP = "PFP",
    PFCS = "PFCS",
    PF = "PF",
    PMA = "PMA",
    HS = "HS",
    PFTTF = "PFTTF",
    PFPTTF = "PFPTTF",
    PFPTT = "PFPTT",
    PFTTNL = "PFTTNL",
    PFPTTNL = "PFPTTNL",
}